import { render } from "./FormFinalized.vue?vue&type=template&id=125153d3"
import script from "./FormFinalized.vue?vue&type=script&lang=js"
export * from "./FormFinalized.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__